import { useCallback } from 'react';

import { SharedState, useSharedStateSelector } from '@trello/shared-state';

interface BetaGASharedState {
  shouldShowGAAnnouncementModal: boolean;
  shouldShowOnboarding: boolean;
  shouldShowSpotlightTour: boolean;
  shouldShowAnnouncementSpotlight: boolean;
}

export const defaultValue: BetaGASharedState = {
  shouldShowGAAnnouncementModal: false,
  shouldShowOnboarding: false,
  shouldShowSpotlightTour: false,
  shouldShowAnnouncementSpotlight: false,
};

export const betaGASharedState = new SharedState<BetaGASharedState>(
  defaultValue,
);

export const openGAAnnouncementModal = () =>
  betaGASharedState.setValue({
    shouldShowGAAnnouncementModal: true,
  });

export const openGAOnboarding = () =>
  betaGASharedState.setValue({
    shouldShowOnboarding: true,
  });

export const closeGAAnnouncementModal = () =>
  betaGASharedState.setValue({
    shouldShowGAAnnouncementModal: false,
  });

export const openGASpotlightTour = () =>
  betaGASharedState.setValue({
    shouldShowSpotlightTour: true,
    shouldShowOnboarding: false,
  });

export const closeGASpotlightTour = () =>
  betaGASharedState.setValue({
    shouldShowSpotlightTour: false,
  });

export const useIsGAAnnouncementModalOpen = () =>
  useSharedStateSelector(
    betaGASharedState,
    useCallback((state) => state.shouldShowGAAnnouncementModal, []),
  );

export const useIsGAOnboardingOpen = () =>
  useSharedStateSelector(
    betaGASharedState,
    useCallback((state) => state.shouldShowOnboarding, []),
  );

export const useIsGASpotlightTourOpen = () =>
  useSharedStateSelector(
    betaGASharedState,
    useCallback((state) => state.shouldShowSpotlightTour, []),
  );

export const showGAAnnouncementSpotlight = () =>
  betaGASharedState.setValue({
    shouldShowAnnouncementSpotlight: true,
  });

export const hideGAAnnouncementSpotlight = () =>
  betaGASharedState.setValue({
    shouldShowAnnouncementSpotlight: false,
  });

export const useIsGAAnnouncementSpotlightOpen = () =>
  useSharedStateSelector(
    betaGASharedState,
    useCallback((state) => state.shouldShowAnnouncementSpotlight, []),
  );
